"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTES_WITHOUT_PAGINATION = exports.OPEN_STREAM_AT_VERY_TOP = exports.PAGINATION_ENABLED = exports.CHANGE_PAGE_NUMBER = exports.SET_MIN_MAX_PAGES = exports.DROP_STATE = exports.NAME = exports.THRESHOLD = void 0;
var core_1 = require("@gin-betting/core");
exports.THRESHOLD = 100; // px, distance from edges of the screen that triggers page loading
/* ACTION TYPES */
exports.NAME = 'pagination';
exports.DROP_STATE = exports.NAME + "/DROP_STATE";
exports.SET_MIN_MAX_PAGES = exports.NAME + "/SET_MIN_MAX_PAGES";
exports.CHANGE_PAGE_NUMBER = exports.NAME + "/CHANGE_PAGE_NUMBER";
exports.PAGINATION_ENABLED = exports.NAME + "/PAGINATION_ENABLED";
exports.OPEN_STREAM_AT_VERY_TOP = exports.NAME + "/OPEN_STREAM_AT_VERY_TOP";
exports.ROUTES_WITHOUT_PAGINATION = [core_1.App.Routes.OUTRIGHTS_LIST];
//# sourceMappingURL=constants.js.map